export const SpinnerActionTypes = {
  setFetchSpinner: 'SPINNER_SET_LOADER',
  setSettingsSpinner: 'SPINNER_SET_SETTINGS_LOADER',
  setTemplateSpinner: 'SPINNER_SET_TEMPLATE_LOADER',
  setCustomerSpinner: 'SPINNER_SET_CUSTOMER_LOADER',
  setConnectDataSpinner: 'SPINNER_SET_CONNECT_DATA_LOADER',
  setConnectToXtmSpinner: 'SPINNER_SET_CONNECT_TO_XTM',
  setConnectToCMSSpinner: 'Spinner_SET_CONNECT_TO_CMS',
};
